import {
  CheckpointTokenError,
  normalizeCheckpointToken,
} from "../../../../packages/shared/src/checkpoint-token.ts";

// Web QR scanning capability + scanned-value handling. QR is Guard Web's PRIMARY capture path: the
// tag carries an opaque chk_ token, resolved + verified server-side. We use the browser-native
// BarcodeDetector where available (Chrome/Edge/Android); iOS Safari + desktop fall back to the
// manual picker. The scanned value is validated against the shared checkpoint-token contract
// (ADR-005) so a random/URL QR never becomes a bad submission.

/** True when the browser exposes the BarcodeDetector API (native QR decode). */
export function barcodeDetectorSupported(win: Window = window): boolean {
  return typeof win !== "undefined" && "BarcodeDetector" in win;
}

export type ScannedTokenResult = { ok: true; token: string } | { ok: false; reason: string };

/**
 * Validate a scanned QR value against the shared opaque-token contract. A non-token value (URL,
 * readable name, garbage) is rejected with a SAFE guard-facing reason — never thrown into render.
 */
export function resolveScannedToken(raw: string): ScannedTokenResult {
  try {
    return { ok: true, token: normalizeCheckpointToken(raw) };
  } catch (error) {
    if (error instanceof CheckpointTokenError) {
      return { ok: false, reason: "That QR code isn't a checkpoint code." };
    }
    return { ok: false, reason: "Couldn't read that QR code." };
  }
}
